import React, { ReactNode } from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import CheckBoxSelected from 'components/CoreIcons/Icons/CheckBoxSelected'
import CheckBoxUnselected from 'components/CoreIcons/Icons/CheckBoxUnselected'
import CheckBoxUndefined from 'components/CoreIcons/Icons/CheckBoxUndefined'

import * as S from './styles'

interface CheckBoxProps {
  disabled?: boolean
  disabledToggleOnClick?: boolean
  iconWidth?: string
  iconHeight?: string
  iconViewBox?: string
  checkBoxId?: string
  title?: string | ReactNode
  customIconColor?: string
  customBorderColor?: string
  indeterminate: boolean
  isSelected: boolean
  onClickCheckBox: (isSelected: boolean) => void
}

const CheckBox = ({
  disabled = false,
  disabledToggleOnClick = false,
  iconWidth = '24px',
  iconHeight = '24px',
  iconViewBox = '0 0 24 24',
  checkBoxId,
  title,
  customIconColor,
  customBorderColor = '',
  indeterminate,
  isSelected,
  onClickCheckBox
}: CheckBoxProps): JSX.Element => {

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    if (disabledToggleOnClick) return null
    onClickCheckBox(!isSelected)
  }

  const Icon = isSelected ? CheckBoxSelected : CheckBoxUnselected
  const fill = disabled ? '#c4c4c4' : customIconColor

  return (
    <S.CheckBoxContainer
      onClick={handleToggle}
      id={checkBoxId}
    >
      <S.CheckBoxIcon
        customBorderColor={customBorderColor}
      >
        {indeterminate
          ? (
            <CheckBoxUndefined
              fill={fill}
              width={iconWidth}
              height={iconHeight}
              viewBox={iconViewBox}
            />
          )
          : (
            <Icon
              fill={fill}
              width={iconWidth}
              height={iconHeight}
              viewBox={iconViewBox}
            />
          )
        }
      </S.CheckBoxIcon>
      <S.CheckBoxText aria-disabled={disabled}>
        <Typography variant='content2'>
          {title}
        </Typography>
      </S.CheckBoxText>
    </S.CheckBoxContainer>
  )
}

export { CheckBox }
